import { EditLoyaltyCollectionRequestDto } from '@src/api';

import { LoyaltyProgramCollection } from '../types';

export const collectionUIToCollectionAPi = (collection: LoyaltyProgramCollection): EditLoyaltyCollectionRequestDto => {
  return {
    ...collection,
    sections: collection.sections.map(section => {
      return {
        contentText: section.contentText,
        products:
          section.products?.map(product => {
            return product.id;
          }) ?? [],
      };
    }),
  };
};
